import { Button } from 'primereact/button';
import React, { useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap';
import useAsegurados from 'redux/hooks/emision/useAsegurados';

const ModalEliminar = ({
  rfc,
  id,
  nombres,
  parentezcoLabel,
  apellidoPaterno,
  apellidoMaterno,
}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { eliminarAsegurado } = useAsegurados();

  const btnEliminar = useMemo(
    () => (
      <Button
        className="p-button-primary p-button-sm btn-block"
        onClick={handleShow}
        label="Eliminar"
      />
    ),
    [],
  );

  const onClickEliminar = async () => {
    handleClose();
    await eliminarAsegurado(id);
  };

  return (
    <div className="d-flex flex-row flex-wrap">
      {btnEliminar}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h1>Eliminar asegurado</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3 className="mt-3">Esta seguro de eliminar al asegurado</h3>

          <h6 className="mt-3">
            <strong>RFC: </strong>
            {rfc}
          </h6>
          <h6>
            <strong>Nombre: </strong>
            {nombres + ' '}
            {apellidoPaterno + ' '}
            {apellidoMaterno + ' '}
          </h6>
          <h6>
            <strong>Parentesco: </strong>
            {parentezcoLabel}
          </h6>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-sm btn-atras-api" onClick={handleClose}>
            Cerrar
          </button>
          <button className="btn btn-sm btn-siguiente-api" onClick={onClickEliminar}>
            Eliminar
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalEliminar;
